import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { LocationService } from "@/services/LocationService";
import { useMember } from "@/contexts/memberContext";

/**
 * React Query hook to fetch permissible locations for the current member
 *
 * Query Key: ["locations", "permissible", memberId]
 * Cache: 15 minutes (locations rarely change)
 *
 * Filters locations based on member role:
 * - Practice managers, admins → all locations
 * - Regular members → only their permissible locations
 */
export function usePermissibleLocationsQuery() {
  const { member } = useMember();
  const locationService = useMemo(() => new LocationService(), []);

  return useQuery({
    queryKey: ["locations", "permissible", member?.id],
    queryFn: () => locationService.getPermissableLocations(),
    enabled: !!member,
    staleTime: 15 * 60 * 1000, // 15 minutes
    refetchOnWindowFocus: false,
    retry: 2,
  });
}
